import { Button, Group, Modal, Text } from "@mantine/core";

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export default function DeleteNotificationModal({ opened, onClose, onConfirm, loading }: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title="Delete Notification" centered size="sm">
      <Text fz="sm" c="dimmed" mb="lg">
        Are you sure you want to Delete this notification? This action can't be UNDONE.
      </Text>
      <Group justify="flex-end">
        <Button style={{ backgroundColor: "#BE220C" }} onClick={onConfirm} loading={loading}>
          Delete
        </Button>
      </Group>
    </Modal>
  );
}
